__turbopack_context__.v({
  "active": "style-module-scss-module__cmm49W__active",
  "component": "style-module-scss-module__cmm49W__component",
});
